export default __webpack_public_path__ + "static/media/healthq3.45b1cc0c.svg";